import { c as _c } from "react/compiler-runtime";
import type { TemplateStats } from "@/lib/api/templates";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { V2_ENDPOINT } from "../consts";
import { authenticatedFetch } from "../lib/authenticatedFetch";

/**
 * React Query hook to fetch aggregate statistics for a template.
 * Uses optional auth so public templates work for unauthenticated users.
 */
export function useTemplateStats(templateId) {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== templateId) {
    t0 = ["template-stats", templateId];
    t1 = async () => {
      if (!templateId) {
        throw new Error("Template ID is required");
      }
      const url = `${V2_ENDPOINT}/v1/templates/${templateId}/stats`;
      const response = await authenticatedFetch(url, {
        optionalAuth: true,
        showErrorToast: false
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch template stats: ${response.status}`);
      }
      const json = await response.json();
      return json.data as TemplateStats;
    };
    $[0] = templateId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = Boolean(templateId);
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 300000,
      gcTime: 1800000,
      retry: _temp
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
}
function _temp(failureCount, error) {
  return !error.message.includes(": 404") && !error.message.includes(": 410") && failureCount < 1;
}